import React, { forwardRef } from 'react';
import clsx from 'clsx';

import { Spinner, withErrorMessage, ArrowRightIcon } from '@ag1/ui';

import { FooterInputBaseProps, FooterInputProps } from './types';
import styles from './styles.module.scss';

const FooterInputBase = forwardRef<HTMLInputElement, FooterInputBaseProps>(
  (
    {
      buttonLabel,
      isSuccess,
      successMessage,
      hasError,
      errorMessage,
      isLoading,
      className,
      ...inputProps
    },
    ref
  ) => (
    <div>
      <div
        className={clsx(
          styles.inputContainer,
          hasError && styles.error,
          isSuccess && styles.success,
          isLoading && styles.loading,
          className
        )}>
        <input {...inputProps} ref={ref} type="text" className={styles.input} aria-label="Email" />
        <button
          type="submit"
          aria-label={buttonLabel}
          className={styles.button}
          data-testid="footer-email-subscription-submit-button">
          {isLoading ? <Spinner size={24} withOverlay={false} /> : <ArrowRightIcon />}
        </button>
        {isSuccess && successMessage && <p className={styles.message}>{successMessage}</p>}
      </div>
      {hasError && errorMessage && <p className={styles.messageUnder}>{errorMessage}</p>}
    </div>
  )
);

FooterInputBase.displayName = 'FooterInputBase';

export default withErrorMessage<HTMLInputElement, FooterInputProps>(FooterInputBase);
